module.exports = __webpack_public_path__ + "img/position.bb8273da.svg";